const Brand = (props) => <>ZIS portál</>

export default Brand;
